import { render, staticRenderFns } from "./ChatSection.vue?vue&type=template&id=8ae81280"
import script from "./ChatSection.vue?vue&type=script&lang=js"
export * from "./ChatSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports